<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      :validate-on-rule-change="false"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_supplier') || '供应商'"
            prop="supCode"
          >
            <dict-select
              v-model="formData.supCode"
              :selectedLabel.sync="formData.supName"
              url="/master/common/dict/scmCooperated"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              filterable
              clearable
              @change="scmChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_contacts') || '工厂联系人'"
            prop="contactName"
          >
            <el-input
              v-model="formData.contactName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_contact_phone') || '联系人手机'"
            prop="contactMobile"
          >
            <el-input
              v-model="formData.contactMobile"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="11"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_buyer_source') || '是否合祥采购'"
            prop="buyerSource"
          >
             <dict-select
              v-model="formData.buyerSource"
              url="/digitalCenter/common/dict/biz"
              :body="{ dictType: 'buyerSource' }"
              :placeholder="$l('tips_select_data_buyer_source') || '请选择是否合祥采购'"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_buyer_by') || '合祥采购员'"
            prop="buyerBy"
          >
            <dict-select
              v-model="formData.buyerBy"
              :selectedLabel.sync="formData.buyerByName"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('tips_select_buyer_by') || '请选择合祥采购员'"
              size="mini"
              filterable
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="5">
          <el-form-item
            :label="$l('INDEX.label_customer') || '客户'"
            prop="custCode"
          >
            <dict-select
              v-model="formData.custCode"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              url="/digitalCenter/common/dict/customer"
              size="mini"
              clearable
              filterable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$l('form_label_bill_name') || '业务员'"
            prop="fabricAgentCode"
          >
            <dict-select
              v-model="formData.fabricAgentCode"
              :selectedLabel.sync="formData.fabricAgentName"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              filterable
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$l('form_label_start_date') || '开发依赖日期'"
            prop="requestDate"
          >
            <el-date-picker
              v-model="formData.requestDate"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              type="date"
              value-format="yyyy-MM-dd"
              clearable
              style="width:100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$l('form_label_finish_date') || '要求完成日期'"
            prop="finishDate"
          >
            <el-date-picker
              v-model="formData.finishDate"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              type="date"
              value-format="yyyy-MM-dd"
              clearable
              style="width:100%"
            />
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item :label="$l('form_label_seasonName') || '适用季节'">
            <dict-select
            v-model="formData.seasonList"
            url="/master/common/dict/biz"
            :body="{ dictType: 'productSeason' }"
            :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
            :options="{ label: 'label', value: 'this' }"
            size="mini"
            filterable
            clearable
            multiple
          />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item prop="fabricUse" class="el-form-item-fabric-use">
            <div
              slot="label"
              style="width: 100%;display: flex;justify-content: space-between;margin-bottom: 2px;"
            >
              <div>
                {{ $l('form_label_purpose') || '面料用途' }}
              </div>
              <el-button
                v-if="!disabled"
                type="primary"
                size="mini"
                plain
                @click.stop="openChooseFabricUse()"
              >
                {{ $l('btn_label_chooseFabricUse') || '选择面料用途' }}
              </el-button>
            </div>

            <el-input
              v-model="formData.fabricUse"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="500"
              type="textarea"
              show-word-limit
              readonly
              clearable
              :autosize="{ minRows: 5, maxRows: 5 }"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="fabricMemo">
            <div slot="label" style="margin-bottom: 2px;">
              {{ $l('form_label_memo') || '备注' }}
            </div>
            <el-input
              v-model="formData.fabricMemo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="500"
              type="textarea"
              show-word-limit
              clearable
              :autosize="{ minRows: 5, maxRows: 5 }"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_fabric_name') || '面料'"
            prop="fabricDescriptionArray"
          >
            <dict-select
              v-model="formData.fabricDescriptionArray"
              url="/digitalCenter/master/fabric/attributes/attributesSelect"
              :body="{ fabricAttrTypeEn: 'Fabric Description' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :options="{ label: 'label', value: 'this' }"
              size="mini"
              filterable
              clearable
              multiple
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_flowerType') || '花型'"
            prop="patternArray"
          >
            <dict-select
              v-model="formData.patternArray"
              url="/digitalCenter/master/fabric/attributes/attributesSelect"
              :body="{ fabricAttrTypeEn: 'Pattern' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :options="{ label: 'label', value: 'this' }"
              size="mini"
              filterable
              clearable
              multiple
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_technology') || '工艺'"
            prop="techniqueArray"
          >
            <dict-select
              v-model="formData.techniqueArray"
              url="/digitalCenter/master/fabric/attributes/attributesSelect"
              :body="{ fabricAttrTypeEn: 'Technique' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :options="{ label: 'label', value: 'this' }"
              size="mini"
              filterable
              clearable
              multiple
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_function') || '功能'"
            prop="functionArray"
          >
            <dict-select
              v-model="formData.functionArray"
              url="/digitalCenter/master/fabric/attributes/attributesSelect"
              :body="{ fabricAttrTypeEn: 'Function' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :options="{ label: 'label', value: 'this' }"
              size="mini"
              filterable
              clearable
              multiple
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_materialNotes') || '材料'"
            prop="constructionArray"
          >
            <dict-select
              v-model="formData.constructionArray"
              url="/digitalCenter/master/fabric/attributes/attributesSelect"
              :body="{ fabricAttrTypeEn: 'Construction' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :options="{ label: 'label', value: 'this' }"
              size="mini"
              filterable
              clearable
              multiple
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_fabricCompositionChinese') || '面料成分中文'"
            prop="fabricContent"
          >
            <FabricContentInput
              :fabricContent.sync="formData.fabricContent"
              :fabricContentEn.sync="formData.fabricContentEn"
              :disabled="disabled"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_factoryNumber') || '工厂面料编号'"
            prop="factoryNumber"
          >
            <el-input
              v-model.trim="formData.factoryNumber"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="3">
          <el-form-item
            :label="$l('form_label_fabric_width') || '有效门幅'"
            prop="wid"
          >
            <el-input-number
              v-model="formData.wid"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :min="0"
              :precision="2"
              :controls="false"
              style="width:100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('form_label_fabric_width_unit') || '门幅单位'"
            prop="widUnit"
          >
            <dict-select
              v-model="formData.widUnit"
              url="/digitalCenter/common/dict/biz"
              :body="{ dictType: 'widUnit' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('form_label_fabric_weight') || '面料克重'"
            prop="fabricWeight"
          >
            <el-input-number
              v-model="formData.fabricWeight"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :min="0"
              :precision="2"
              :controls="false"
              style="width:100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('form_label_fabric_weight_unit') || '面料克重单位'"
            prop="fabricWeightUnit"
          >
            <dict-select
              v-model="formData.fabricWeightUnit"
              url="/digitalCenter/common/dict/biz"
              :body="{ dictType: 'fabricWeightUnit' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_density') || '密度'">
            <el-input
              v-model="formData.density"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_yarn_count') || '纱织'">
            <el-input
              v-model="formData.yarnCount"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="3">
          <el-form-item
            :label="$l('form_label_unitPrice') || '单价'"
            prop="unitPrice"
          >
            <el-input-number
              v-model="formData.unitPrice"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :min="0"
              :precision="2"
              :controls="false"
              style="width:100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('form_label_fabric_unit') || '面料单位'"
            prop="fabricUnit"
          >
            <dict-select
              v-model="formData.fabricUnit"
              url="/digitalCenter/common/dict/biz"
              :body="{ dictType: 'fabricYarnUnit' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('form_label_request_total_quantity') || '需求总数量'"
          >
            <el-input v-model="formData.requestQuantity" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item :label="$l('form_label_request_amount') || '面料金额'">
            <el-input v-model="requestAmount" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('form_label_request_requestFee') || '附加费'"
            prop="requestFee"
          >
            <el-input-number
              v-model="formData.requestFee"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :min="0"
              :precision="2"
              :controls="false"
              style="width:100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item :label="$l('form_label_total_price') || '合计金额'">
            <el-input v-model="requestTotalAmount" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_requestMetre') || '需求总米数'">
            <el-input v-model="formData.requestMetre" readonly />
          </el-form-item>
        </el-col>
      </el-row>
      <FabricColor
        ref="fabricColor"
        class="mt-4"
        :fabricRequestCode="fabricRequestCode"
        :fabricRequest="formData"
        :disabled="disabled"
        @change="colorChange"
      />
    </el-form>

    <ChooseScmContacts
      :visible.sync="chooseScmContactsVisible"
      :title="`${formData.supName} ${$l('dialog_title_contacts') || '联系人'}`"
      :scmCode="formData.supCode"
      @confirm="scmContactsConfirm"
    />
    <ChooseFabricUse
      :visible.sync="fabricUseVisible"
      :title="$l('btn_label_chooseFabricUse') || '选择面料用途'"
      @confirm="fabricUseConfirm"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FabricContentInput from '@/views/digital/components/fabric-content-input'
import FabricColor from '../fabric-color'
import ChooseFabricUse from '../choose-fabric-use'
import ChooseScmContacts from '@/views/digital/components/choose-scm-contacts'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import { add, multiplyRound } from '@/libs/util.number.js'
export default {
  mixins: [EditLoading],
  components: {
    FabricContentInput,
    FabricColor,
    ChooseScmContacts,
    ChooseFabricUse,
  },
  props: {
    fabricRequestCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {
        contactName: '',
        contactMobile: '',
        fabricAgentCode: '',
        fabricAgentName: '',
        widUnit: 'cm',
        fabricWeightUnit: 'gsm',
        requestQuantity: 0,
        requestMetre: 0,
      },
      chooseScmContactsVisible: false,
      fabricUseVisible: false,
    }
  },
  computed: {
    ...mapState('admin/user', { userInfo: 'info' }),
    isTulip() {
      const { supCode } = this.formData
      // 判断是否是【苏州合祥纺织科技有限公司】
      return supCode === 'e667dc86-dfb9-11e7-807f-f0def1247d1f'
    },
    rules() {
      return {
        supCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        contactName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        contactMobile: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        custCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        fabricAgentCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        requestDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        finishDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        fabricUse: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        fabricDescriptionArray: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        patternArray: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        fabricContent: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
        factoryNumber: [
          {
            required: this.isTulip,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        wid: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        widUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        fabricWeight: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        fabricWeightUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        unitPrice: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        fabricUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
        requestFee: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
        buyerSource: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
        buyerBy: [
          {
            required: this.formData.buyerSource === 'hx',
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
      }
    },
    requestAmount() {
      const { requestQuantity, unitPrice } = this.formData
      return multiplyRound(requestQuantity, unitPrice, 2)
    },
    requestTotalAmount() {
      const { requestFee } = this.formData
      return add(this.requestAmount, requestFee)
    },
  },
  watch: {
    userInfo: {
      handler() {
        if (this.fabricRequestCode) return
        if (!this.userInfo) return
        const { userCode, userName, userNameEn } = this.userInfo || {}
        this.formData.fabricAgentCode = userCode || ''
        this.formData.fabricAgentName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.fabricRequestCode) return
      const res = await this.$api
        .fabricRequestDetailApi({ fabricRequestCode: this.fabricRequestCode })
        .catch(() => null)
      if (!res) return
      const data = res.body
      this.formData = { ...data }
      this.$emit('loaded', data)

      this.$refs.fabricColor.getData()
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      const listColor = await this.$refs.fabricColor.getTableData()
      if (!listColor?.length) {
        this.$message({
          message: this.$l('tips_warning_colorEmpty') || '请添加面料颜色明细',
          type: 'warning',
        })
        return
      }

      if (this.loadingOpen()) return
      const res = await this.$api
        .fabricRequestSaveApi({ ...this.formData, listColor })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status, body } = res
      if (status !== 200 || !body) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      if (this.fabricRequestCode) return this.getData()

      const { fabricRequestCode, fabricRequestNo } = body
      this.$router.replace({
        name: 'master-fabricRequest-detail',
        params: { fabricRequestCode, pageType: 'edit' },
        query: { fabricRequestNo },
      })
    },
    async scmChange(scmCode) {
      if (!scmCode) return

      const res = await this.$api
        .scmInfoContactsListApi({ scmCode })
        .catch(() => null)
      if (!res) return

      const { data } = res.body
      if (!data || !data.length) return
      if (data.length > 1) return (this.chooseScmContactsVisible = true)

      const { contactName, contactMobile } = data[0]
      this.formData.contactName = contactName
      this.formData.contactMobile = contactMobile
    },
    scmContactsConfirm({ contactName, contactMobile } = {}) {
      this.formData.contactName = contactName
      this.formData.contactMobile = contactMobile
    },
    colorChange(data) {
      if (!data?.length) {
        this.formData.requestQuantity = 0
        this.formData.requestMetre = 0
        return
      }

      const requestQuantity = data
        .map((item) => item.requestQuantity)
        .reduce((r, n) => add(r, n), 0)
      const requestMetre = data
        .map((item) => item.requestMetre)
        .reduce((r, n) => add(r, n), 0)

      this.formData.requestQuantity = requestQuantity
      this.formData.requestMetre = requestMetre
    },
    openChooseFabricUse() {
      this.fabricUseVisible = true
    },
    fabricUseConfirm({ label }) {
      this.formData.fabricUse = label
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
.side-frame-success {
  padding: 1px 10px;
  border-left: 3px solid $color-success;
  margin: 15px 0;
}
.group-title {
  font-size: 14px;
  color: #606266;
}

::v-deep {
  .el-input__inner {
    text-align: start;
  }
}
::v-deep {
  .el-form-item-fabric-use {
    .el-form-item__label {
      position: relative;
      z-index: 1;
      width: 100%;
      text-align: left;
      padding: 0;
      display: flex;
      align-items: center;
    }
  }
}
</style>
